import Vue from 'vue';

import 'vant/lib/index.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@vant/touch-emulator';

import {
  Button,
  Field,
  Toast,
  Dialog,
  Loading,
} from 'vant';


Vue.use(Button);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Loading);
